import { LayoutSchema } from '@updater/ui-informant';

export const screens = {
  confirmAddresses: 'confirm-addresses',
  currentAddress: 'current-address',
  forwardDate: 'forward-mail-date',
  isMoveTemporary: 'is-move-temporary',
  name: 'name',
  newAddress: 'new-address',
  review: 'review',
  stopForwardMailDate: 'stop-forward-mail-date',
  verifyCurrentAddress: 'verify-current-address',
  verifyNewAddress: 'verify-new-address',
  whosMoving: 'who-is-moving',
};

/**
 * Informant layout schema for Forward your Mail flow
 */

export const layoutSchema: LayoutSchema = {
  screens: [
    {
      name: screens.confirmAddresses,
      heading: 'Confirm your addresses',
      route: screens.confirmAddresses,
      fields: ['confirmAddresses'],
      nextButtonText: 'Looks good',
    },
    {
      name: screens.currentAddress,
      heading: "What's your CURRENT address?",
      subHeading: 'Please provide or confirm your current address.',
      route: screens.currentAddress,
      fields: ['currentAddress'],
      hideNextButton: true,
    },
    {
      name: screens.newAddress,
      heading: "What's your NEW address?",
      subHeading: 'Please provide or confirm your new address.',
      route: screens.newAddress,
      fields: ['newAddress'],
      hideNextButton: true,
    },
    {
      name: screens.whosMoving,
      heading: 'Who’s moving?',
      route: screens.whosMoving,
      fields: ['whosMoving'],
      hideNextButton: true,
    },
    {
      name: screens.name,
      heading: 'What is your name?',
      route: screens.name,
      fields: ['firstName', 'middleName', 'lastName', 'suffixName'],
    },
    {
      name: screens.forwardDate,
      heading: 'When do you want to start forwarding your mail?',
      route: screens.forwardDate,
      fields: ['forwardMailDate'],
    },
    {
      name: screens.isMoveTemporary,
      heading: 'Is your move temporary?',
      route: screens.isMoveTemporary,
      fields: ['isMoveTemporary'],
    },
    {
      name: screens.stopForwardMailDate,
      heading: 'When do you want to stop forwarding mail?',
      route: screens.stopForwardMailDate,
      fields: ['stopForwardMailDate'],
    },
    {
      name: screens.review,
      heading: 'Review your info',
      route: screens.review,
      fields: ['review'],
      nextButtonText: 'Submit',
    },
  ],
  basePath: '/forward-mail/move-info/',
};
